import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import portadaImg from '../../assets/images/portada.png';
import amazonImg from '../../assets/images/amazon.png';
import mercadoPagoImg from '../../assets/images/mp.jpg';
import fragmentoPdf from '../../assets/pdfs/fragmento_el_poder_de_las_afirmaciones.pdf';
import ebookPdf from '../../assets/pdfs/ebook_el_poder_de_las_afirmaciones.pdf';
import UrlConfig from '../../data/UrlConfig';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AfirmacionesPage = () => {
  const query = useQuery();
  const mode = query.get('mode');
  const config = UrlConfig;
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [nick, setNick] = useState('');
  const [user, setUser] = useState({});
  const [errors, setErrors] = useState({ email: '', nick: '' });
  const [mensajeExito, setMensajeExito] = useState('¡Tu Fragmento fue descargado!');

  useEffect(() => {
    document.body.className = 'bg-black text-white';
    let data = localStorage.getItem('userSM');
    if (data) {
      let userSM = JSON.parse(data);
      userSM.fragmentoDownloaded = userSM.statuses?.some(item => item.page === 'afirmaciones' && item.section === 'fragmento' && item.status === 'downloaded');
      userSM.ebookDownloaded = userSM.statuses?.some(item => item.page === 'afirmaciones' && item.section === 'ebook' && item.status === 'downloaded');
      setEmail(userSM.email);
      setNick(userSM.nick);
      setUser(userSM);
    }
    return () => { document.body.className = ''; };
  }, []);

  const validar = () => {
    const nuevosErrores = { email: '', nick: '' };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) nuevosErrores.email = 'Ingresá un email válido';
    if (!nick.trim()) nuevosErrores.nick = 'El nombre es obligatorio';
    setErrors(nuevosErrores);
    return !nuevosErrores.email && !nuevosErrores.nick;
  };

  const pagar = () => {
    localStorage.setItem('userSM', JSON.stringify({ ...user, pagoAfirmaciones: 'doing' }));
    const link = document.createElement('a');
    link.href = 'https://mpago.la/2RcQArg';
    link.target = '_self';
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const descargarEbook = async (section) => {
    const datos = { email, nick, page: 'afirmaciones', section, status: 'downloaded' };
    try {
      const response = await fetch(config.resourcesApi, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos),
      });
      const resultado = await response.json();
      if (resultado.status === 'success') {
        setMensajeExito('¡Tu Ebook está en camino! Revisa tu carpeta de descargas.');
        const newStatus = { page: 'afirmaciones', section, status: 'downloaded' };
        const updatedUser = {
          ...user,
          email,
          nick,
          statuses: [...(user.statuses || []), newStatus],
          [`${section}Downloaded`]: true,
        };
        localStorage.setItem('userSM', JSON.stringify(updatedUser));
        setUser(updatedUser);
        const link = document.createElement('a');
        link.href = section === 'ebook' ? ebookPdf : fragmentoPdf;
        link.download = `El Poder de las Afirmaciones (${section}).pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validar()) await descargarEbook('fragmento');
  };

  return (
    <div className="min-h-screen p-6 text-white bg-black font-sans">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl sm:text-5xl font-bold text-center mb-8">El Poder de las Afirmaciones</h1>

        <div className="flex justify-center mb-10">
          <img src={portadaImg} alt="Portada" className="rounded-lg w-60 shadow-xl" />
        </div>

        <p className="text-lg text-gray-300 text-center max-w-3xl mx-auto mb-6">
          Descubre el método que utilicé para encontrar una relación de pareja profunda y real.
        </p>

        {!user.fragmentoDownloaded && user.pagoAfirmaciones !== 'done' && (
          <form onSubmit={handleSubmit} className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-md mx-auto mb-10">
            <div className="mb-4">
              <label className="block mb-2 text-sm">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                     className="w-full px-4 py-2 rounded bg-gray-700 text-white border border-gray-600" />
              {errors.email && <p className="text-red-400 text-sm mt-1">{errors.email}</p>}
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm">Nombre</label>
              <input type="text" value={nick} onChange={e => setNick(e.target.value)}
                     className="w-full px-4 py-2 rounded bg-gray-700 text-white border border-gray-600" />
              {errors.nick && <p className="text-red-400 text-sm mt-1">{errors.nick}</p>}
            </div>
            <button type="submit" className="w-full bg-purple-500 hover:bg-purple-600 py-3 rounded font-bold text-white transition">Descargar Fragmento</button>
          </form>
        )}

        {user.fragmentoDownloaded && user.pagoAfirmaciones !== 'done' && (
          <div className="text-center text-green-400 text-xl font-bold mb-10">{mensajeExito}</div>
        )}

        {user.pagoAfirmaciones !== 'done' && (
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">¿List@ para más?</h2>
            <p className="text-gray-300 mb-2">Si estás dispuesto a aplicar las técnicas, accedé al libro completo a un precio promocional.</p>
            <p className="text-lg text-purple-400 font-semibold mb-6">Solo hoy: <strong>$3 USD</strong> (En Amazon está a $7)</p>

            <div className="flex justify-center gap-4 mb-8">
              <a href="https://www.amazon.com/-/es/Gustavo-Nahuel-Aguiar-ebook/dp/B0DVLW1DNC" target="_blank" className="flex items-center px-6 py-3 bg-gray-700 hover:bg-gray-600 rounded-lg shadow transition">
                <span className="mr-3 font-semibold">Ebook Amazon</span>
                <img src={amazonImg} alt="Amazon" className="w-8 h-8" />
              </a>
              <button onClick={pagar} className="flex items-center px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg shadow transition">
                <span className="mr-3 font-semibold">Pago Promo</span>
                <img src={mercadoPagoImg} alt="MercadoPago" className="w-8 h-8" />
              </button>
            </div>
            <p className="text-sm text-gray-400">Luego del pago se habilita el botón de descarga del ebook completo.</p>
          </div>
        )}

        {user.pagoAfirmaciones === 'done' && (
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-md mx-auto mt-10">
            <div className="mb-4">
              <label className="block mb-2 text-sm">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                     className="w-full px-4 py-2 rounded bg-gray-700 text-white border border-gray-600" />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm">Nombre</label>
              <input type="text" value={nick} onChange={e => setNick(e.target.value)}
                     className="w-full px-4 py-2 rounded bg-gray-700 text-white border border-gray-600" />
            </div>
            <button onClick={() => descargarEbook('ebook')} className="w-full bg-green-500 hover:bg-green-600 py-3 rounded font-bold text-white transition">Descargar Ebook</button>
          </div>
        )}

        {user.pagoAfirmaciones === 'done' && user.ebookDownloaded && (
          <div className="text-center text-green-400 text-xl font-bold mt-6">Tu Ebook fue descargado. Revisá la carpeta de descargas.</div>
        )}

      </div>
    </div>
  );
};

export default AfirmacionesPage;